import axios from "axios";

// Libs
import {getTokenFromLocalStorage} from "../auth/auth";
import utilsLib from "../common/libs/utils-lib";

// Constants
export const FETCH_DELIVERY_NOTES_REQUEST = "FETCH_DELIVERY_NOTES_REQUEST";
export const FETCH_DELIVERY_NOTES_SUCCESS = "FETCH_DELIVERY_NOTES_SUCCESS";
export const FETCH_DELIVERY_NOTES_ERROR = "FETCH_DELIVERY_NOTES_ERROR";
export const CLEAN_DELIVERY_NOTES_STATE = "CLEAN_DELIVERY_NOTES_STATE";

export const readDeliveryNotes = (filters = {}) => {
    return async (dispatch) => {
        try {
            dispatch(fetchDeliveryNotesRequest());

            const token = getTokenFromLocalStorage();

            const res = await axios.post('/api/delivery-notes', {filters}, { headers: { 'Authorization': 'Bearer ' + token } });
            
            dispatch(utilsLib.response(res, fetchDeliveryNotesSuccess, fetchDeliveryNotesError));
        } catch (err) {
            dispatch(utilsLib.response(err, fetchDeliveryNotesError));
        }
    };
};

const fetchDeliveryNotesRequest = () => {
    return {
        type: FETCH_DELIVERY_NOTES_REQUEST
    };
};

const fetchDeliveryNotesSuccess = (payload) => {
    return {
        type: FETCH_DELIVERY_NOTES_SUCCESS,
        payload
    };
};

const fetchDeliveryNotesError = (errorMessage) => {
    return {
        type: FETCH_DELIVERY_NOTES_ERROR,
        errorMessage
    };
};

export const cleanDeliveryNotesState = () => {
    return {
        type: CLEAN_DELIVERY_NOTES_STATE
    }
}